import { inAuthWidget } from '@whistler-ui/portal/routes/Root';
import { useAuthStore } from '@whistler-ui/portal/store/auth';
import { useEntitlementsStore } from '@whistler-ui/portal/store/entitlements';
import { useEffect } from 'react';

export const useEntitlementsBootstrap = () => {
  const {
    authValues: {
      loggedUser,
      organisationState: { isValidProductionUpgrade },
    },
  } = useAuthStore();
  const { getEnvironments } = useEntitlementsStore();

  useEffect(() => {
    if (inAuthWidget || !loggedUser || isValidProductionUpgrade === undefined) {
      return;
    }
    getEnvironments({ isValidProductionUpgrade });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedUser, isValidProductionUpgrade]);
};
